import { useQueryClient } from 'react-query'

export type UseUTMQueryParams = () => {
  utm_source?: string
  utm_medium?: string
  utm_campaign?: string
}

const useUTMQueryParams: UseUTMQueryParams = () => {
  const queryClient = useQueryClient()

  return {
    utm_source: queryClient.getQueryData('utmSource'),
    utm_medium: queryClient.getQueryData('utmMedium'),
    utm_campaign: queryClient.getQueryData('utmCampaign'),
  }
}

export default useUTMQueryParams
